import styles from './miniQuizMailboxIcon.module.less';

export const MiniQuizMailboxIcon = () => {
  return (
    <div className={styles.mailIconWrapper} role="presentation">
      <div className={styles.inboxNotification}>
        <span>1</span>
      </div>

      {/* The Mail icon in the zola-ui V3 library has spacing around
  it which makes placing the notification icon relative to the 
  top right corner basically impossible, so I exported the
  mail icon without the padding and pasted it here. */}
      <svg width="40" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="36" height="28" rx="4" stroke="#0E0E0E" strokeWidth="4" />
        <path d="m2 6 18 12L38 6" stroke="#0E0E0E" strokeWidth="4" />
      </svg>
    </div>
  );
};
